export default "__VITE_ASSET__CByLVvbL__"